"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDashboardContentPut = void 0;
exports.dashboardContentPutSetMock = dashboardContentPutSetMock;
exports.dashboardContentPut = dashboardContentPut;
exports.useMutationDashboardContentPut = useMutationDashboardContentPut;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function dashboardContentPutSetMock(mock) {
    setMock = mock;
}
async function dashboardContentPut(body, params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(body, params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/dashboard/content/${params.id}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { data: body, headers, method: 'PUT', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyDashboardContentPut = 'wolf-dashboard-service:dashboardContentPut:put';
function useMutationDashboardContentPut(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyDashboardContentPut }, mutationOptions));
}
function mutationFn({ body, params }) {
    const promise = dashboardContentPut(body, params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=dashboard-content-put.js.map